import { createBrowserRouter } from 'react-router-dom';
import RoutingErrorFallback from './components/RoutingErrorFallback';
import Logout from './auth/Logout';
import UserReadyRouteListener from './analytics/UserReadyRouteListener';

import Menu from './Menu';

const router = createBrowserRouter([
  {
    element: <UserReadyRouteListener />,
    errorElement: <RoutingErrorFallback />,
    children: [
      { path: '/', element: <Menu /> },
      { path: '/login', lazy: () => import('./auth/Login') },
      { path: '/logout', element: <Logout /> },
      { path: '/v1bridge', lazy: () => import('./v1bridge/V1Bridge') },
      { path: '/smartdataanalyst', lazy: () => import('./smartdataanalyst/SmartDataAnalystEmbed') },
      {
        path: '/subscriber_settings',
        lazy: () => import('./subscription/SubscriberSettings')
      },
      { path: '/subscription', lazy: () => import('./subscription/Subscription') },
      { path: '/dashboards', lazy: () => import('./dashboard/DashboardList') },
      { path: '/dashboard/:id', lazy: () => import('./dashboard/Dashboard') },
      { path: '/image-viewer', lazy: () => import('./components/ImageViewerPage') },
      { path: '/form', lazy: () => import('./dynamicdata/CustomFormList') },
      { path: '/productsv2', lazy: () => import('./product/ProductList') },
      { path: '/productv2/new', lazy: () => import('./product/Product') },
      { path: '/productv2/:id', lazy: () => import('./product/Product') },
      { path: '/distributornetworks', lazy: () => import('./distributor/DistributorList') },
      { path: '/distributornetwork/new', lazy: () => import('./distributor/DistributorDetails') },
      { path: '/distributornetwork/:id', lazy: () => import('./distributor/DistributorDetails') },
      { path: '/warehouses', lazy: () => import('./distributor/DistributorList') },
      { path: '/warehouse/new', lazy: () => import('./distributor/DistributorDetails') },
      { path: '/warehouse/:id', lazy: () => import('./distributor/DistributorDetails') },
      { path: '/targets', lazy: () => import('./target/TargetList') },
      { path: '/schedulingwizard', lazy: () => import('./schedulingwizard/PlanList.js') },
      { path: '/tagging', lazy: () => import('./planogram/TaggingList') },
      { path: '/training', lazy: () => import('./planogram/ModelTraining') },
      { path: '/import/:entityType', lazy: () => import('./import/Import.js') },
      { path: '/bulkoperations', lazy: () => import('./queue/QueueList.js') },
      { path: '/tagging/tagmanagment/', lazy: () => import('./planogram/TagManagmentList.js') },
      { path: '/prediction/', lazy: () => import('./planogram/TaggingList') },
      { path: '/planogram/', lazy: () => import('./planogram/TaggingList') },
      { path: '/mlproducts/', lazy: () => import('./planogram/MLProductList.js') },
      { path: '/warrantyperiods/', lazy: () => import('./bip/WarrantyPeriodList.js') },
      { path: '/integrations', lazy: () => import('./integration/IntegrationList.js') },
      { path: '/integrations/:integrationTypeId/inspect', lazy: () => import('./integration/gemini/GeminiInspect.js') },
      { path: '/integrations/:integrationTypeId', lazy: () => import('./integration/Integration.js') },
      { path: '/campaigns/', lazy: () => import('./campaign/CampaignList') },
      { path: '/campaign/new', lazy: () => import('./campaign/Campaign') },
      { path: '/campaign/:id', lazy: () => import('./campaign/Campaign') },
      { path: '/bippromotions/', lazy: () => import('./bip/BipPromotionList.js') },
      { path: '/warehousetransfers', lazy: () => import('./warehousetransfer/WarehouseTransferList.js') },
      { path: '/warehousetransfer/new', lazy: () => import('./warehousetransfer/WarehouseTransfer.js') },
      { path: '/warehousetransfer/:id', lazy: () => import('./warehousetransfer/WarehouseTransfer.js') },
      { path: '/stockmovements', lazy: () => import('./stock/StockMovementList.js') },
      { path: '/bipstatistics/', lazy: () => import('./bip/BipStatistics.js') },
      { path: '/internalmessages/', lazy: () => import('./internalmessage/InternalMessageList.js') },
      { path: '/internalmessage/new', lazy: () => import('./internalmessage/InternalMessage.js') },
      { path: '/internalmessage/:id', lazy: () => import('./internalmessage/InternalMessage.js') },
      { path: '/dashboardaccess', lazy: () => import('./dashboardaccess/DashboardAccess.js') },
      { path: '/reports', lazy: () => import('./report/Reports.js') },
      { path: '/visits/map', lazy: () => import('./map/VisitMap.js') },
      { path: '/clients/map', lazy: () => import('./map/ClientMap.js') },
      { path: '/map-colors', lazy: () => import('./map/MapColorSettings.js') },
      { path: '/trialonboardingvideos', lazy: () => import('./trialonboardingvideo/TrialOnboardingVideoList.js') },
      { path: '/trialonboardingvideoplayer', lazy: () => import('./trialonboardingvideo/TrialOnboardingVideoPlayer.js') },
      { path: '/reports', lazy: () => import('./report/Reports.js') },
      { path: '/pricingmanagement', lazy: () => import('./pricingmanagement/PricingManagement.js') },
      { path: '/pricingmanagement/new', lazy: () => import('./pricingmanagement/PricingManagementCreate.js') },
      { path: '/pricingmanagement/:id/edit', lazy: () => import('./pricingmanagement/PricingManagementEdit.js') }
    ]
  }
]);

export default router;
